module.exports = __webpack_public_path__ + "static/images/usa_flag-e23c29411e396afb1f2a77bb38e73514.svg";